import React from 'react';
import {Link} from 'react-router-dom'
import {useSelector} from 'react-redux';
import {useLocation} from "react-router-dom";
import './FooterNav.css';

export default function FooterNav() {
    const location = useLocation();
    const role = useSelector((state) => state.userdata?.role);

    // Функция для проверки активного пути
    const isActive = (path) => {
        return location.pathname === path;
    }

    return(
        <>
        {role===1 && 
        <div className='footerNav'>
            <Link to='/dms' className={`navLink ${isActive('/dms') ? 'active' : ''}`}>Все машины</Link>
            <Link to='/imeis' className={`navLink ${isActive('/imeis') ? 'active' : ''}`}>IMEI</Link>
            <Link to='/users' className={`navLink ${isActive('/users') ? 'active' : ''}`}>Пользователи</Link>
        </div>}
        </>
    )
}

